import { ENDPOINTS } from "../constants";

const buildRequestUrl = (parameters) => {
  const partnerId = parameters["criteo-partner-id"];
  const host = ENDPOINTS[partnerId];

  const searchParams = new URLSearchParams(parameters);
  searchParams.sort();

  return `https://${host}/delivery/retailmedia?${searchParams.toString()}`;
};

export default buildRequestUrl;
